import { apiRequest } from './api';

// ── Types ───────────────────────────────────────────────────

export type DiscountCalculationType = 'percentage' | 'fixed';

export const DISCOUNT_CALC_TYPE_OPTIONS: { value: DiscountCalculationType; label: string }[] = [
    { value: 'percentage', label: 'Percentage' },
    { value: 'fixed', label: 'Fixed Amount' },
];

export type FeeDiscountRecord = {
    id: string;
    organization_id: string;
    school_id: string;
    name: string;
    calculation_type: DiscountCalculationType;
    value: number;
    applicable_fee_head_id: string | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    applicable_fee_head?: { id: string; name: string } | null;
};

export type FeeDiscountPayload = {
    school_id: string;
    name: string;
    calculation_type: DiscountCalculationType;
    value: number;
    applicable_fee_head_id?: string | null;
    is_active?: boolean;
};

// ── API Functions ───────────────────────────────────────────

export async function fetchFeeDiscounts(params?: {
    school_id?: string;
}): Promise<FeeDiscountRecord[]> {
    const query = new URLSearchParams();
    if (params?.school_id) query.set('school_id', params.school_id);
    const qs = query.toString();
    const res = await apiRequest<FeeDiscountRecord[]>(`/api/fee-discounts${qs ? `?${qs}` : ''}`);
    return res.data;
}

export async function createFeeDiscount(payload: FeeDiscountPayload): Promise<FeeDiscountRecord> {
    const res = await apiRequest<FeeDiscountRecord>('/api/fee-discounts', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res.data;
}

export async function updateFeeDiscount(
    id: string,
    payload: Partial<Omit<FeeDiscountPayload, 'school_id'>>
): Promise<FeeDiscountRecord> {
    const res = await apiRequest<FeeDiscountRecord>(`/api/fee-discounts/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    });
    return res.data;
}

export async function deleteFeeDiscount(id: string): Promise<void> {
    await apiRequest(`/api/fee-discounts/${id}`, { method: 'DELETE' });
}

export async function assignDiscountToStudent(
    studentId: string,
    feeDiscountId: string
): Promise<unknown> {
    const res = await apiRequest(`/api/students/${studentId}/fee-discount`, {
        method: 'PUT',
        body: JSON.stringify({ fee_discount_id: feeDiscountId }),
    });
    return res.data;
}
